import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const loginPasswordReducer = createReducer<State, Actions>(initialState, {
  [actions.login.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.login.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.login.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.login.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default loginPasswordReducer;
